/**
 * 通用文案 —— English
 * key = 中文原文；必须与 zh-CN/common.ts 逐条对应（差集为零）
 */
export default {
  // ---- 通用按钮 ----
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '新增': 'Add',
  '编辑': 'Edit',
  '删除': 'Delete',
  '保存': 'Save',
  '提交': 'Submit',
  '搜索': 'Search',
  '重置': 'Reset',
  '刷新': 'Refresh',
  '返回': 'Back',
  '上传': 'Upload',
  '下载': 'Download',
  '预览': 'Preview',
  '详情': 'Details',
  '更多': 'More',
  '导出': 'Export',
  '导入': 'Import',
  '确认': 'Confirm',
  '展开': 'Expand',
  '收起': 'Collapse',
  '复制': 'Copy',
  '全部': 'All',

  // ---- 通用字段 ----
  '状态': 'Status',
  '操作': 'Actions',
  '标题': 'Title',
  '类型': 'Type',
  '名称': 'Name',
  '备注': 'Remark',
  '分类': 'Category',
  '排序': 'Sort',
  '金额': 'Amount',
  '关键词': 'Keyword',
  '描述': 'Description',
  '内容': 'Content',
  '简介': 'Summary',
  '图片': 'Image',
  '链接': 'Link',
  '角色': 'Role',
  '企业': 'Company',
  '管理员': 'Admin',
  '权限': 'Permission',
  '用户': 'User',
  '账号': 'Account',
  '密码': 'Password',
  '手机号': 'Mobile',
  '姓名': 'Name',
  '联系人': 'Contact',
  '企业名称': 'Company Name',
  '英文名称': 'English Name',
  '创建时间': 'Created At',
  '更新时间': 'Updated At',
  '分站域名': 'Sub-site Domain',
  '推荐': 'Featured',

  // ---- 状态值 ----
  '启用': 'Enabled',
  '禁用': 'Disabled',
  '停用': 'Disabled',
  '正常': 'Normal',
  '未知': 'Unknown',
  '待审核': 'Pending Review',
  '已驳回': 'Rejected',
  '处理中': 'Processing',
  '成功': 'Success',
  '失败': 'Failed',
  '是': 'Yes',
  '否': 'No',

  // ---- 提示语 ----
  '操作成功': 'Done',
  '操作失败': 'Operation failed',
  '删除成功': 'Deleted',
  '删除失败': 'Delete failed',
  '保存成功': 'Saved',
  '保存失败': 'Save failed',
  '创建成功': 'Created',
  '更新成功': 'Updated',
  '加载中': 'Loading…',
  '暂无数据': 'No data',
  '网络错误': 'Network error',
  '确定删除': 'Confirm delete',
  '请选择': 'Please select',
  '请输入': 'Please enter',
  '提示': 'Notice',
  '警告': 'Warning',
  '错误': 'Error',
  '记得点保存': 'Remember to save',
  '绑定企业': 'Bind Company',
  '解绑': 'Unbind',

  // ---- 登录 ----
  '登录': 'Sign In',
  '退出登录': 'Sign Out',
  '验证码': 'Verification Code',
  '忘记密码': 'Forgot password',
  '记住我': 'Remember me',
  '请输入手机号': 'Enter your mobile number',
  '请输入密码': 'Enter your password',
  '请输入验证码': 'Enter the verification code',
  '获取验证码': 'Get code',
  '手机号或密码错误': 'Wrong mobile number or password',
  '登录成功': 'Signed in',
  '登录失败': 'Sign-in failed',
  '正在登录': 'Signing in…',

  // ---- 站点 ----
  '企庭管理系统': 'chpen Enterprise Management',
  '管理后台': 'Admin',

  // ---- 第二批补充：带标点的提示 / 更多通用词 ----
  '确定删除？': 'Confirm delete?',
  '上传图片': 'Upload Image',
  '选择文件': 'Select File',
  '请求失败': 'Request failed',
  '参数错误': 'Invalid parameters',
  '未登录': 'Not signed in',
  '登录已过期': 'Session expired',
  '无权限': 'No permission',
  '加载失败': 'Failed to load',
  '重试': 'Retry',
  '查看': 'View',
  '修改': 'Modify',
  '设置': 'Settings',
  '配置': 'Settings',
  '列表': 'List',
  '总数': 'Total',
  '保存并发布': 'Save & Publish',
  '已启用': 'Enabled',
  '已禁用': 'Disabled',
  '保存中': 'Saving…',
  '提交中': 'Submitting…',
  '清空': 'Clear',
  '批量删除': 'Bulk Delete',
  '启用成功': 'Enabled',
  '禁用成功': 'Disabled',
  '添加': 'Add',
  '生效': 'Active',
  '失效': 'Expired',
  '上线': 'Online',
  '下线': 'Offline',
  '公开': 'Public',
  '隐藏': 'Hidden',
  '置顶': 'Pinned',
  '发布': 'Publish',
  '撤回': 'Withdraw',
  '审核': 'Review',
  '驳回': 'Reject',
  '通过': 'Approved',
  '拒绝': 'Rejected',
  '说明': 'Description',
  '单位': 'Unit',
  '数量': 'Quantity',
  '价格': 'Price',
  '时间': 'Time',
  '日期': 'Date',
  '来源': 'Source',
  '作者': 'Author',
  '手机号不能为空': 'Mobile number is required',
  '密码不能为空': 'Password is required',
};
